import { render, staticRenderFns } from "./piccard.vue?vue&type=template&id=39de6ec1&scoped=true"
import script from "./piccard.vue?vue&type=script&lang=js"
export * from "./piccard.vue?vue&type=script&lang=js"
import style0 from "./piccard.vue?vue&type=style&index=0&id=39de6ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de6ec1",
  null
  
)

export default component.exports